export default __webpack_public_path__ + "static/media/peds.manual2.6bac8477.pdf";